exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accept-account-page .terms-label .callout{color:#0096d6}.accept-account-page .terms-label:hover{color:#0096d6;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/accept/account/accept-account.scss
// module id = 129
// module chunks = 0